<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        :style="{ float: 'right' }"
        @onSearchDoctor="onSearchDoctor"
        @onSearchPromoter="onSearchPromoter"
        @onStartTime="onStartTime"
        @onEndTime="onEndTime"
        @onChangeType="onChangeType"
        @onExport="onExport"
      />
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="promoter_list"
          slot-scope="text, record"
        >
          <span>
            {{ record.promoter_list.map(item=>item.user_realname).join('、') }}
          </span>
        </template>
        <template
          slot="video_url"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="handleVideo(record)"
          ><a-icon type="video-camera" /></a>
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            style="{pointerEvents: none;}"
            :disabled-class="{disabledClass:status==='1'}"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <video-modal
      :data="videoData"
      :visible="videoVisible"
      @onCancel="cancelVideo"
    />
  </div>
</template>
<script>
import { columns } from './data/index';
import TableSearch from './components/search.vue';
import videoModal from './modal/index';
export default {
  components: { TableSearch, videoModal },
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      visible: false,
      id: '',
      videoVisible: false,
      videoData: '',
      start_time: '',
      end_time: '',
      doctor_name: '',
      promoter_name: '',
      status: '',
      token: '',
      drug_id: '',
    };
  },
  mounted() {
    this.token = localStorage.getItem('token');
    this.drug_id = localStorage.getItem('companyId');
    // 获取表格数据
    this.getTableData({
      page: this.current,
      pageSize: this.pageSize,
      status: this.status,
      start_time: this.start_time,
      end_time: this.end_time,
      admin_name: this.admin_name,
      promoter_name: this.promoter_name,
    });
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/portalPost/getDoctorVideo', params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.create_time,
            name: item.name,
            speaker: item.speaker,
            promoter_list: item.promoter_list,
            create_time: this.$Format(item.create_time),
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // 查看视频
    handleVideo(record) {
      console.log('handleAnswer -> record', record.data.video_url);
      this.videoVisible = true;
      this.videoData=record.data.video_url;
    },
    // 取消查看反馈
    cancelVideo() {
      this.videoVisible = false;
    },
    // 搜索医生
    onSearchDoctor(value) {
      this.current = 1;
      this.doctor_name = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        status: this.status,
        start_time: this.start_time,
        end_time: this.end_time,
        doctor_name: this.doctor_name,
        promoter_name: this.promoter_name,
      });
    },
    // 推广员搜索
    onSearchPromoter(value) {
      this.current = 1;
      this.promoter_name = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        status: this.status,
        start_time: this.start_time,
        end_time: this.end_time,
        doctor_name: this.doctor_name,
        promoter_name: this.promoter_name,
      });
    },
    // 上传时间搜索
    onStartTime(value) {
      this.current = 1;
      this.start_time = this.$Date(value);
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        status: this.status,
        start_time: this.start_time,
        end_time: this.end_time,
        doctor_name: this.doctor_name,
        promoter_name: this.promoter_name,
      });
    },
    onEndTime(value) {
      this.current = 1;
      this.end_time = this.$Date(value);
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        status: this.status,
        start_time: this.start_time,
        end_time: this.end_time,
        doctor_name: this.doctor_name,
        promoter_name: this.promoter_name,
      });
    },
    // 类型搜索
    onChangeType(value) {
      this.current = 1;
      this.status = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        status: this.status,
        start_time: this.start_time,
        end_time: this.end_time,
        doctor_name: this.doctor_name,
        promoter_name: this.promoter_name,
      });
    },
    // 导出
    onExport(){
      console.log('this.status', this.status);
      console.log('this.doctor_name', this.doctor_name);
      console.log('this.promoter_name', this.promoter_name);
      console.log('this.start_time', this.start_time);

      window.location.href=`${this.uploadUrl}portalPost/exportVideo?
       doctor_name=${this.doctor_name?this.doctor_name:''}&status=${this.status?this.status:''}&promoter_name=${this.promoter_name?this.promoter_name:''}
       &start_time=${this.start_time}&end_time=${this.end_time}
       &token=${this.token}`;
    },
    // 分页
    changePage(pagination) {
      this.current = pagination.current;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        status: this.status,
        start_time: this.start_time,
        end_time: this.end_time,
        doctor_name: this.doctor_name,
        promoter_name: this.promoter_name,
      });
    },
    // 删除

    async onDelete(record){
      let result = await this.$http.post('/portalPost/postDel', {id: record.data.id});
      if (result.data.status === 1) {
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          status: this.status,
          start_time: this.start_time,
          end_time: this.end_time,
          doctor_name: this.doctor_name,
          promoter_name: this.promoter_name,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.disabledClass{
    pointer-events: none;
    color: rgba(0,0,0,.25);
  }

</style>
